<template>
  <div id="data-list-list-view" class="data-list-container">
    <!-- INICIO SIDEBAR NOVA SITUAÇÃO -->
    <AddNewDataSidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="addNewDataSidebar = false"
      :form="formSideBar"
      :title="titleSideBar"
      :dados="dadosSideBar"
      @concluido="concluido"
    />
    <!-- FIM SIDEBAR NOVA SITUAÇÃO -->
    <!-- INICIO TABELA -->
    <vs-table
      noDataText="Nenhuma situação de evento cadastrada"
      ref="table"
      class="tablePrincipal"
      search
      pagination
      multiple
      :data="itens"
      :max-items="itemsPorPagina"
      v-model="itensSelecionados"
    >
      <!-- INICIO HEADER  -->
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex">
          <!-- INICIO MENU DE AÇÕES -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
            >
              <span class="mr-2">Ações</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item
                @click="ativar()"
                v-if="$can($actionsDefault.Escrita, subjectPermission)"
              >
                <span>Ativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                @click="inativar()"
                v-if="$can($actionsDefault.Escrita, subjectPermission)"
              >
                <span>Inativar</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <!-- FIM MENU DE AÇÕES -->
          <!-- INICIO BOTÃO NOVA SITUAÇÃO -->
          <ActionButtonNew
            :subjectPermission="subjectPermission"
            @toggleSideBar="novaSituacao()"
            >Nova Situação</ActionButtonNew
          >
          <!-- FIM BOTÃO NOVA SITUAÇÃO -->
        </div>
        <!-- INICIO PAGINAÇÃO -->
        <SelectPagination
          :currentPage="paginaAtual"
          :itemsPerPage="itemsPorPagina"
          :length="itens.length"
          @update="itemsPorPagina = $event"
        />
        <!-- FIM PAGINAÇÃO -->
      </div>
      <!-- FIM HEADER -->
      <!-- INICIO TITULO TABELA -->
      <template slot="thead">
        <vs-th sort-key="nomeStatus">Nome</vs-th>
        <vs-th sort-key="status">Status</vs-th>
        <vs-th>Cor</vs-th>
        <vs-th>Ações</vs-th>
      </template>
      <!-- FIM TITULO TABELA -->
      <!-- INICIO CORPO TABELA -->
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ tr.nomeStatus }}</vs-td>
            <vs-td
              ><vs-chip :color="chipColor(tr.deletedAt)">{{
                statusName(tr.deletedAt)
              }}</vs-chip></vs-td
            >
            <vs-td><vs-chip :color="tr.corStatus"></vs-chip></vs-td>
            <vs-td>
              <vs-button
                radius
                v-tooltip="'Editar'"
                color="success"
                type="gradient"
                icon-pack="feather"
                icon="icon-edit"
                class="d-inline"
                @click="openSideBar(tr)"
                v-if="$can($actionsDefault.Escrita, subjectPermission)"
              ></vs-button>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
      <!-- FIM CORPO TABELA -->
    </vs-table>
    <!-- FIM TABELA -->
  </div>
</template>
<script>
import AddNewDataSidebar from '../../../Includes/SideBar.vue';
import ActionButtonNew from '../../../../utils/list/header/ActionButtonNew.vue';
import SelectPagination from '../../../../utils/list/header/SelectPagination.vue';
import notify from '../../../../utils/notify.js';
import utils from '../../../../utils/list';
import utilsLocal from '../utils/';

export default {
  components: {
    AddNewDataSidebar,
    ActionButtonNew,
    SelectPagination,
  },
  props: ['subjectPermission'],
  data() {
    return {
      itemsPorPagina: 10,
      itens: [],
      itensSelecionados: [],
      paginaCarregada: false,
      addNewDataSidebar: false,
      dadosSideBar: {},
      titleSideBar: 'Adicionar Situação de Evento',
      formSideBar: 'SituaçãoEvento',
      statusName: utils.getAtivoInativoByDeletedAt,
      chipColor: utils.getColorAtivoInativoByDeletedAt,
    };
  },
  computed: {
    paginaAtual() {
      if (this.paginaCarregada) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    async ativar() {
      if (this.itensSelecionados.length) {
        const situacoes = this.itensSelecionados.map((s) => {
          return { ...s, deletedAt: null };
        });
        await this.atualizar(situacoes);
      }
    },
    async inativar() {
      if (this.itensSelecionados.length) {
        const situacoes = this.itensSelecionados.map((s) => {
          return { ...s, deletedAt: new Date() };
        });
        await this.atualizar(situacoes);
      }
    },
    async atualizar(situacoes) {
      try {
        this.$vs.loading();
        await utilsLocal.atualizarSituacoes(situacoes);
        await this.buscarDados();
        this.itensSelecionados = [];
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    novaSituacao() {
      this.openSideBar({});
    },
    async buscarDados() {
      try {
        this.$vs.loading();
        this.itens = await utilsLocal.bucarSituacoes();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    openSideBar(dados) {
      dados.idStatus == null
        ? (this.titleSideBar = `Adicionar Situação de Evento`)
        : (this.titleSideBar = `Editar Situação de Evento`);
      this.dadosSideBar = dados;
      this.addNewDataSidebar = true;
    },
    concluido() {
      this.buscarDados();
    },
  },
  mounted() {
    this.paginaCarregada = true;
  },
  created() {
    this.buscarDados();
  },
};
</script>
<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
